import * as React from 'react';

import { EmptyField, TextAndIconField } from '../../../../../../components/Field/common';
import { INFRASTRUCTURE_ICONS_MAP } from './constants';
import { useOfferContext } from '../../../../../../utils/offerContext';

export const FeaturesFieldContainer: React.VFC = () => {
  const { newbuilding, published } = useOfferContext();
  const features = newbuilding && newbuilding.infrastructure;

  const displayFeatures = React.useMemo(
    () =>
      features
        ? features.map(feature => ({ icon: INFRASTRUCTURE_ICONS_MAP.get(feature.type), text: feature.text }))
        : [],
    [features],
  );

  if (!displayFeatures.length) {
    return <EmptyField published={published} />;
  }

  return <TextAndIconField published={published} items={displayFeatures} />;
};
